"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupSchema = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var antd_1 = require("antd");
var collectionsRef_1 = require("common/db/collectionsRef");
var currenciesList_1 = require("common/global/currenciesList");
var getIndexFromText_1 = require("common/utils/getIndexFromText");
var formik_1 = require("formik");
var lodash_1 = require("lodash");
var index_modules_css_1 = __importDefault(require("portal/index.modules.css"));
var react_1 = __importStar(require("react"));
var firestore_1 = require("react-firebase-hooks/firestore");
var react_i18next_1 = require("react-i18next");
var react_router_dom_1 = require("react-router-dom");
var Yup = __importStar(require("yup"));
exports.SignupSchema = Yup.object().shape({
    companyName: Yup.string()
        .min(2)
        .max(75)
        .required(),
    contactPerson: Yup.string().required(),
    city: Yup.string().required(),
    country: Yup.string().required(),
    mobilePhone: Yup.number().required(),
    physicalAddress: Yup.string().required(),
});
var Option = antd_1.Select.Option;
function SupplierEdit() {
    var _this = this;
    var _a;
    var t = (0, react_i18next_1.useTranslation)().t;
    // useTitle(t('common.editSupplier'))
    var params = (0, react_router_dom_1.useParams)();
    var supplierSnapshot = (0, firestore_1.useDocument)(collectionsRef_1.suppliersRef.doc((_a = params.supplierId) !== null && _a !== void 0 ? _a : "noSupplier"))[0];
    var formProps = (0, formik_1.useFormik)({
        validationSchema: exports.SignupSchema,
        initialValues: {
            companyName: "",
            companyNumber: 0,
            contactPerson: "",
            city: "",
            businessType: "",
            country: "",
            email: "",
            accountName: "",
            iban: "",
            bankName: "",
            currencyId: "",
            mobilePhone: 0,
            physicalAddress: "",
            website: "",
            notes: "",
            active: true,
        },
        onSubmit: function (values, form) { return __awaiter(_this, void 0, void 0, function () {
            var e_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, collectionsRef_1.suppliersRef.doc((_a = params.supplierId) !== null && _a !== void 0 ? _a : collectionsRef_1.suppliersRef.doc().id).set({
                                companyName: values.companyName,
                                companyNumber: values.companyNumber,
                                contactPerson: values.contactPerson,
                                city: values.city,
                                businessType: values.businessType,
                                country: values.country,
                                email: values.email,
                                mobilePhone: values.mobilePhone,
                                physicalAddress: values.physicalAddress,
                                website: values.website,
                                iban: values.iban,
                                bankName: values.bankName,
                                currencyId: values.currencyId,
                                accountName: values.accountName,
                                notes: values.notes,
                                active: values.active,
                                nameIndex: (0, getIndexFromText_1.getIndexFromText)(values.companyName),
                            })];
                    case 1:
                        _b.sent();
                        antd_1.message.success(t("alerts.success"));
                        form.resetForm();
                        history.back();
                        return [3 /*break*/, 3];
                    case 2:
                        e_1 = _b.sent();
                        console.log(e_1);
                        antd_1.message.error(t("alerts.error"));
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); },
    });
    var _b = (0, react_1.useState)(false), loaded = _b[0], setLoaded = _b[1];
    (0, react_1.useEffect)(function () {
        if (!supplierSnapshot || loaded || !supplierSnapshot.data()) {
            return;
        }
        var supplier = supplierSnapshot === null || supplierSnapshot === void 0 ? void 0 : supplierSnapshot.data();
        setLoaded(true);
        formProps.setValues({
            companyName: supplier.companyName,
            companyNumber: supplier.companyNumber,
            contactPerson: supplier.contactPerson,
            city: supplier.city,
            businessType: supplier.businessType,
            country: supplier.country,
            email: supplier.email,
            mobilePhone: supplier.mobilePhone,
            physicalAddress: supplier.physicalAddress,
            website: supplier.website,
            iban: supplier.iban,
            bankName: supplier.bankName,
            currencyId: supplier.currencyId,
            accountName: supplier.accountName,
            notes: supplier.bankName,
            active: supplier.active,
        });
    }, [supplierSnapshot, formProps, loaded]);
    var formItemLayout = {
        labelCol: {
            xs: { span: 26 },
            sm: { span: 4 },
        },
        wrapperCol: {
            xs: { span: 24 },
            sm: { span: 16 },
        },
    };
    return ((0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.profileBox }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: index_modules_css_1.default.infoBox }, { children: (0, jsx_runtime_1.jsxs)(antd_1.Form, __assign({}, formItemLayout, { children: [(0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("companyName").touched) &&
                                formProps.errors.companyName &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("companyName").touched) &&
                                formProps.errors.companyName, label: t("suppliers.companyName"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.companyName, onChange: function (e) {
                                    return formProps.setFieldValue("companyName", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("country").touched) &&
                                formProps.errors.country &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("country").touched) &&
                                formProps.errors.country, label: t("suppliers.country"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.country, onChange: function (e) {
                                    return formProps.setFieldValue("country", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("city").touched) &&
                                formProps.errors.city &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("city").touched) &&
                                formProps.errors.city, label: t("suppliers.city"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.city, onChange: function (e) {
                                    return formProps.setFieldValue("city", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("physicalAddress").touched) &&
                                formProps.errors.physicalAddress &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("physicalAddress").touched) &&
                                formProps.errors.physicalAddress, label: t("suppliers.physicalAddress"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.physicalAddress, onChange: function (e) {
                                    return formProps.setFieldValue("physicalAddress", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("email").touched) &&
                                formProps.errors.email &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("email").touched) &&
                                formProps.errors.email, label: t("suppliers.email") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.email, onChange: function (e) {
                                    return formProps.setFieldValue("email", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("contactPerson").touched) &&
                                formProps.errors.contactPerson &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("contactPerson").touched) &&
                                formProps.errors.contactPerson, label: t("suppliers.contactPerson"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.contactPerson, onChange: function (e) {
                                    return formProps.setFieldValue("contactPerson", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("bankName").touched) &&
                                formProps.errors.accountName &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("bankName").touched) &&
                                formProps.errors.bankName, label: t("suppliers.bankName") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.bankName, onChange: function (e) {
                                    return formProps.setFieldValue("bankName", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("accountName").touched) &&
                                formProps.errors.accountName &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("accountName").touched) &&
                                formProps.errors.accountName, label: t("suppliers.accountName") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.accountName, onChange: function (e) {
                                    return formProps.setFieldValue("accountName", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("iban").touched) &&
                                formProps.errors.iban &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("iban").touched) &&
                                formProps.errors.iban, label: t("suppliers.iban") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.iban, onChange: function (e) {
                                    return formProps.setFieldValue("iban", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("currencyId").touched) &&
                                formProps.errors.currencyId &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("currencyId").touched) &&
                                formProps.errors.currencyId, label: t("common.currency") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Select, __assign({ showSearch: true, optionFilterProp: "children", value: formProps.values.currencyId, onChange: function (e) { return formProps.setFieldValue("currencyId", e); } }, { children: (0, lodash_1.map)(currenciesList_1.globalCurrenciesData, function (value, key) {
                                    return ((0, jsx_runtime_1.jsx)(Option, __assign({ value: value.id }, { children: value.name }), key));
                                }) })) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("companyNumber").touched) &&
                                formProps.errors.companyNumber &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("companyNumber").touched) &&
                                formProps.errors.companyNumber, label: t("suppliers.companyNumber") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.companyNumber, onChange: function (e) {
                                    return formProps.setFieldValue("companyNumber", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("mobilePhone").touched) &&
                                formProps.errors.mobilePhone &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("mobilePhone").touched) &&
                                formProps.errors.mobilePhone, label: t("suppliers.mobileNumber"), required: true }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.mobilePhone, onChange: function (e) {
                                    return formProps.setFieldValue("mobilePhone", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("website").touched) &&
                                formProps.errors.website &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("website").touched) &&
                                formProps.errors.website, label: t("common.website") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.website, onChange: function (e) {
                                    return formProps.setFieldValue("website", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("businessType").touched) &&
                                formProps.errors.businessType &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("businessType").touched) &&
                                formProps.errors.businessType, label: t("suppliers.businessType") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { className: index_modules_css_1.default.formInputs, value: formProps.values.businessType, onChange: function (e) {
                                    return formProps.setFieldValue("businessType", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Form.Item, __assign({ validateStatus: (formProps.submitCount ||
                                formProps.getFieldMeta("notes").touched) &&
                                formProps.errors.notes &&
                                "error", help: (formProps.submitCount ||
                                formProps.getFieldMeta("notes").touched) &&
                                formProps.errors.notes, label: t("common.notes") }, { children: (0, jsx_runtime_1.jsx)(antd_1.Input, { style: { height: 100 }, className: index_modules_css_1.default.formInputs, value: formProps.values.notes, onChange: function (e) {
                                    return formProps.setFieldValue("notes", e.target.value);
                                } }) })), (0, jsx_runtime_1.jsx)(antd_1.Button, __assign({ loading: formProps.isSubmitting, type: "primary", onClick: formProps.submitForm }, { children: t("common.save") }))] })) })) })) })));
}
exports.default = SupplierEdit;
